/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createContainer,
	createSubscriber,
	createHook,
	type BoundActions,
	type HookFunction,
	type OverrideContainerComponent,
	type SubscriberComponent,
} from '@atlassian/react-sweet-state';
import * as actions from '../actions/index.tsx';
import type { State } from '../actions/types.tsx';
import type { Actions } from '../types.tsx';

type MetaGetter = (name: string) => string | null;

type PropType = {
	getMeta: MetaGetter;
};

const initialState: State = {
	navigationTheme: {
		shouldShowTitle: false,
		logoUrl: '',
		usesCustomColours: false,
		backgroundColor: '',
		highlightColor: '',
	},
};

const Store = createStore<State, Actions>({
	name: 'theme',
	initialState,
	actions,
});

export const ThemeSubscriber: SubscriberComponent<
	State,
	BoundActions<State, typeof actions>,
	unknown
> = createSubscriber<State, Actions>(Store);

export const useTheme: HookFunction<State, BoundActions<State, typeof actions>, void> = createHook(
	Store,
);

export const ThemeContainer: OverrideContainerComponent<PropType> = createContainer<
	State,
	Actions,
	PropType
>(Store, {
	onInit: actions.bootstrap,
});
